module.exports = __webpack_public_path__ + "img/4.8ccf3898.png";